import React, { useState } from "react";
import { Box, Container, Tab, Tabs, Typography } from "@mui/material";
import { FinancialStatementsDashboard } from "features/admin/reports/FinancialStatementsDashboard";
import { BiDashboard } from "features/admin/reports/BiDashboard";
import { Header } from "components/shared";
import { useUtility } from "utils/context/UtilityContext";
import { motion } from "framer-motion";

function TabPanel(props: {
  children?: React.ReactNode;
  index: number;
  value: number;
}) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export const ReportsDashboard = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { marginBottomHeader } = useUtility();

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className={`${marginBottomHeader} flex flex-col items-center justify-start gap-4 overflow-x-hidden fancy-scroll`}
    >
      <Header secondPart={false} />
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Reports Dashboard
        </Typography>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs value={tabIndex} onChange={handleTabChange}>
            <Tab label="Business Intelligence" />
            <Tab label="Financial Statements" />
          </Tabs>
        </Box>
        <TabPanel value={tabIndex} index={0}>
          <BiDashboard />
        </TabPanel>
        <TabPanel value={tabIndex} index={1}>
          <FinancialStatementsDashboard />
        </TabPanel>
      </Container>
    </motion.div>
  );
};
